 <template>
  <v-dialog v-model="classRemarks2.dialog" max-width="800px">
    <v-card v-if="!isLoading">
      <v-card-title class="title blue-title pa-3 pt-4 ml-2">
        Class Remarks
        <div class="header-close" title="close" @click="classRemarks2.dialog = false">
          <v-icon>close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md pt-0 px-2>
          <v-layout wrap>
              <v-flex xs12 v-if="this.LessonType">
                <v-card-title class="pl-0 pb-0 pt-0">
                    <label class="form-title">Test Score (Please fill in numbers)</label><span class="required-text">*</span>
                </v-card-title>
                <p class="correct-info xs12 mt-2 mb-4 blue-text-normal">
                    <span>Correct: </span>
                    <v-flex xs3 class="float">
                    <v-text-field class="mx-3" type="number" single-line outline v-model="classRemarksForm.CorrectNum"
                                :error-messages="$v.classRemarksForm.CorrectNum.$error ? 'Required': ''"
                                @input="$v.classRemarksForm.CorrectNum.$touch()"
                    ></v-text-field>
                    </v-flex>
                    <span>out of</span>
                    <v-flex xs3 class="float">
                    <v-text-field class="mx-3" single-line outline type="number" v-model="classRemarksForm.TotalNum"
                                :error-messages="$v.classRemarksForm.TotalNum.$error ? 'Required': ''"
                                @input="$v.classRemarksForm.TotalNum.$touch()"
                    ></v-text-field>
                    </v-flex>
                    <span>items</span>
                </p>
            </v-flex>
            <!-- 易起口语杯赛事测评课 教材id-1290 易建联星火项目 -->
            <v-flex xs12 mb-2 v-if="info.IsShowScore">
              <v-card-title class="pl-0 pt-0">
                <label class="blue-title-2">Learning objectives assessment：</label><span class="required-text">*</span>
              </v-card-title>
              <v-layout>
                <v-flex xs3 v-for="(item,index) in objectivesList" :key="item">
                  <v-btn class="text-none objectives-btn" 
                        :class="classRemarksForm.EvaluationState===index+2?'red-button':'red-border-button'" 
                        @click="classRemarksForm.EvaluationState=index+2">{{item}}</v-btn>
                </v-flex>
              </v-layout>
              <p v-if="$v.classRemarksForm.EvaluationState.$error" class="pink-text">Required</p>
            </v-flex>
            <v-flex xs12>
                <v-card-title class="pl-0 pt-0">
                    <label class="blue-title-2">Learning and Mastering</label><span class="required-text">*</span>
                </v-card-title>

                <v-layout>
                    <v-flex xs12>
                        <v-layout class="align-center" v-for="(item, index) in starList" :key="index" nowrap>
                            <v-flex xs12>
                                <rateStar class="py-0"
                                :title="item.title"
                                :descriptions="item.descriptions"
                                v-model="classRemarksForm.rates[item.title]"
                                @input="$v.classRemarksForm.rates[item.title].$touch()" />
                            </v-flex>
                            <span class="error--text"
                                    v-if="$v.classRemarksForm.rates[item.title].$error">Required.</span>
                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-flex>

            <v-flex xs12>
                <v-card-title class="pl-0 pt-4">
                    <label class="blue-title-2">Performance of Class</label><span class="required-text">*</span>
                </v-card-title>

                <v-layout>
                    <v-flex xs12>
                        <v-layout class="align-center" v-for="(item, index) in starList2" :key="index" nowrap>
                            <v-flex xs12>
                                <rateStar class="py-0"
                                :title="item.title" :descriptions="item.descriptions"
                                 v-model="classRemarksForm.rates[item.title]"
                                @input="$v.classRemarksForm.rates[item.title].$touch()" />
                            </v-flex>
                            <span class="error--text"
                                    v-if="$v.classRemarksForm.rates[item.title].$error">Required</span>
                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-flex>

            <v-flex xs12>
                <v-card-title class="pl-0">
                    <label class="blue-title-2">Correction of class</label>
                </v-card-title>
                <!-- <v-flex xs8>
                    <span class="tips">If there is no word/grammar error, you may not fill it in.</span>
                </v-flex> -->
            </v-flex>

            <v-flex xs12>
                <v-card-title class="pl-0 pb-0 pt-0">
                    <label class="blue-title font-weight-regular">Word</label>
                </v-card-title>
                <div class="grammar-box">
                    <template>
                        <v-chip close v-for="(item,index) in GrammarList" :key="index" @input="removeGrammar(item,index)">{{ item }}</v-chip>
                    </template>
                    <input v-model="wordKey" @keyup.enter="onSubmit" @blur="onSubmit" placeholder="Input the right word directly and press ENTER  to add up to 9 words."/>
                </div>
                <div class="grammar-error">
                    <span class="error--text" v-if="grammarError.maxCharacters">The maximum length of a single word is 20 characters.</span>
                    <span class="error--text" v-if="grammarError.maxLength">Add up to 9 words</span>
                </div>
            </v-flex>

            <v-flex xs12>
                <v-card-title class="pl-0 pb-0 pt-0">
                    <label class="blue-title font-weight-regular">Grammar</label>
                </v-card-title>
                <v-textarea name="input-7-4" counter maxlength="800"
                single-line
                outline
                required
                placeholder="Sentences with grammatical errors."
                v-model="classRemarksForm.Sentences"></v-textarea>

            </v-flex>

            <v-flex xs12 v-if="wonderfulPictures && wonderfulPictures.length">
              <v-card-title class="pl-0 pb-0 pt-0">
                  <label class="blue-title font-weight-regular">Classroom Highlights</label>
              </v-card-title>
              <v-flex class="display-flex flex-wrap">
                <div v-for="item in wonderfulPictures" :key="item.Id" class="w-picture-card">
                  <v-icon class="picture-close" @click="hidePicture(item.Id)">close</v-icon>
                  <a :href="item.ImagePath" target="_blank">
                    <img :src="item.ImagePath" alt="">
                  </a>
                </div>
              </v-flex>
            </v-flex>

            <v-flex xs12>
                <v-card-title class="pl-0 pb-0 pt-0">
                    <label class="blue-title font-weight-regular">Assessment for Class</label><span class="required-text">*</span>
                </v-card-title>
                <v-flex xs12>
                    <span class="blue-text-normal">Make the assessment consitstent with your in-class comment for the student.</span>
                </v-flex>
                <v-layout row wrap ma-0>
                    <v-flex>
                        <v-textarea outline name="input-7-4" counter minlength="20" maxlength="800"
                        required
                        :error-messages="descriptionErrors"
                        @input="$v.classRemarksForm.Comments.$touch()"
                        v-model="classRemarksForm.Comments"></v-textarea>
                    </v-flex>
                </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
       <v-card-actions class="pa-4">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-btn class="text-none red-button dialog-submit"
                    :loading="submitting"
                    @click="submit">Submit</v-btn>
              <v-btn class="text-none cancel-button"
                    @click="classRemarks2.dialog=false">Cancel</v-btn>
            </v-flex>
          </v-layout>
      </v-card-actions>
    </v-card>
    <v-card v-if="isLoading">
        <v-flex  xs12 text-xs-center mt-4 pt-4 class="pr-3 pb-4">
            <v-progress-circular indeterminate :size="50" class="blue-title-2"></v-progress-circular>
        </v-flex>
    </v-card>
  </v-dialog>
</template>
<script>
import { vipClassRemark, GetUserUserReportByID, GetWonderfulPictures } from '@/api/classtable.js'
import rateStar from './rateStar'
import { createNamespacedHelpers } from 'vuex'
import vmodel from '@/mixins/v-model'
import { validationMixin } from 'vuelidate'
import { required, minValue, minLength, requiredIf } from 'vuelidate/lib/validators'
import { _debounce } from '@/utils/tools.js'

const namespace = 'classDetail'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)

export default {
  computed: {
    ...mapGetters(['info', 'currentLesson', 'remarkInfo']),
    descriptionErrors () {
      const errors = []
      if (!this.$v.classRemarksForm.Comments.$dirty) return errors
      !this.$v.classRemarksForm.Comments.minLength && errors.push('At least 20 characters')
      !this.$v.classRemarksForm.Comments.required && errors.push('Required.')
      return errors
    }
  },
  name: 'classRemarks',
  mixins: [vmodel, validationMixin],
  validations () {
    if (!this.LessonType) {
      return {
        classRemarksForm: {
          Comments: { required, minLength: minLength(20) },
          rates: {
            Vocabulary: { minValue: minValue(1) },
            Speaking: { minValue: minValue(1) },
            Grammar: { minValue: minValue(1) },
            Pronunciation: { minValue: minValue(1) },
            Interest: { minValue: minValue(1) },
            Confidence: { minValue: minValue(1) }
          },
          EvaluationState: { required: requiredIf(function() {
              return this.info.IsShowScore
            }) 
          }
        }
      }
    }
    return {
      classRemarksForm: {
        // Sentences: { required },
        Comments: { required, minLength: minLength(20) },
        rates: {
          Vocabulary: { minValue: minValue(1) },
          Speaking: { minValue: minValue(1) },
          Grammar: { minValue: minValue(1) },
          Pronunciation: { minValue: minValue(1) },
          Interest: { minValue: minValue(1) },
          Confidence: { minValue: minValue(1) }
        },
        CorrectNum: { required },
        TotalNum: { required },
        EvaluationState: { required: requiredIf(function() {
            return this.info.IsShowScore
          }) 
        }
      }
    }
  },
  data: () => ({
    classRemarksForm: {
      description: '',
      Vocabularies: '',
      Sentences: '',
      Comments: '',
      rates: {
        'Vocabulary': 0,
        'Speaking': 0,
        'Grammar': 0,
        'Pronunciation': 0,
        'Interest': 0,
        'Confidence': 0

      },
      ReportID: 0,
      // Sublevel: 0,
      CorrectNum: '',
      TotalNum: '',
      EvaluationState:''
    },
    wordKey: '',
    grammarError: {
      maxCharacters: false,
      maxLength: false
    },
    isLoading: false,
    starList: [
      {
        title: 'Vocabulary',
        descriptions: [
          'The student knows 50%/30%/10% of the words in the beginner/intermediate/advanced teaching materials.',
          'The student knows 90%/60%/30% of the words in the beginner/intermediate/advanced teaching materials.',
          'The student knows 100%/80%/60% of the words in the beginner/intermediate/advanced teaching materials',
          'The student knows 100%/80% of the words in the intermediate/advanced teaching materials',
          'The student knows 100% of the words in the advanced teaching materials'
        ]
      },
      {
        title: 'Speaking',
        descriptions: [
          'The student can only read out some words and phrases',
          'The student can speak out some simple sentences but cannot expression his/her meaning.',
          'The student can speak out some common sentences and is able to express his/her meaning, however, with a lot of errors and hesitations.',
          'The student is able express his/her meaning fluently and logically, but with a little errors.',
          'The student is able to make a fluent speech with logic, without common errors.'
        ]
      }, {
        title: 'Grammar',
        descriptions: [
          'The student has little knowledge of the rules of grammar; 80% mistakes',
          'The student knows the basic rules of grammar but don’t know how to structure sentences with them; 60% mistakes',
          'The student knows the basic rules of grammar and is able to structure simple/short sentences; 40% mistakes',
          'The student know the common rules of grammar and is able to structure complex/long sentences; 20% mistakes',
          'The student is familiar with the rules of grammar and never makes any mistakes'
        ]
      }, {
        title: 'Pronunciation',
        descriptions: [
          'The student has little knowledge of the Ipa(International Phonetic Alphabet) and not able to pronounce most of the vowels & consonants',
          'The student is able to pronounce 50% of the vowels & consonants in the Ipa correctly, on the other hand, knows nothing about the intonation',
          'The student is able to pronounce 80% of the vowels & consonants in the Ipa correctly, on the other hand, knows the basic rules of intonation',
          'The student is able to pronounce all of the vowels & consonants in the Ipa correctly, on the other hand, knows the basic rules of intonation',
          'The student is able to pronounce all of the vowels & consonants in the Ipa correctly, on the other hand, knows the rules of intonation'
        ]
      }
    ],
    starList2: [
      {
        title: 'Interest',
        descriptions: [
          'The student shows absolutely no interest in learning/ refuses to follow instructions/ has behavior problems.',
          'The student is not interested in learning/ hardly follows instructions/ constantly distracted.',
          'The student is able to follow instructions, stays focused most of the time, however, doesn\'t seem to be excited/happy.',
          'The student is interested in learning, gives his/her full attention, seems to enjoy the class and feel excited.',
          'The student shows great interest in learning, is eager to learn, actively participates in the class and enjoys interacting with the teacher.'
        ]
      },
      {
        title: 'Confidence',
        descriptions: [
          'The student feels extremely shy to speak/  seems afraid to talk to the teacher in English.',
          'The student feels a little bit shy to speak English, however, is able to read/answer questions with teacher\'s encourragement.',
          'The student feels comfortable reading the lesson material, is able to speak English somewhat confidently, however, only when he/she is familiar with the topic.',
          'The student can speak English confidently most of the time, however, still feels a little bit afraid of making mistakes/asking questions/expressing ideas.',
          'The student can speak English confidently/ is not afraid of making mistakes/ asks a lot of questions and enjoys expressing her/his ideas in English.'
        ]
      }
    ],
    GrammarList: [],
    LessonType: '',
    submitting:false,
    wonderfulPictures: [],
    objectivesList:['Failed','General','Good','Excellent']
  }),
  props: {
    classRemarks2: {
      dialog: false
    }
  },
  components: {
    rateStar
  },
  created () {
    this.LessonType = this.currentLesson == null ? 0 : this.currentLesson.ClassType
  },
  methods: {
    ...mapActions(['fetchMeterials']),
    GetRemarkInfo (usid) {
      this.isLoading = true
      // if(this.info.AllowLeaveRemark == 1) {
      //     this.isLoading = false
      //     // this.LessonType = this.currentLesson == null ? 0 : this.currentLesson.ClassType
      //     return
      // }
      GetUserUserReportByID(usid).then(res => {
        this.GrammarList = res.Vocabularies ? res.Vocabularies.split(',') : this.GrammarList
        this.classRemarksForm.Sentences = res.Sentences
        this.classRemarksForm.Comments = res.Description
        this.classRemarksForm.CorrectNum = res.CorrectNum
        this.classRemarksForm.TotalNum = res.TotalNum
        this.LessonType = res.LessonType || this.LessonType
        if (res.ReportModel != null) {
          var result = JSON.parse(res.ReportModel.ReportJosn)
          var rates = this.classRemarksForm.rates
          this.classRemarksForm.ReportID = res.ReportModel.ReportID
          this.classRemarksForm.EvaluationState = res.ReportModel.EvaluationState
          rates.Vocabulary = result[0].Score
          rates.Speaking = result[1].Score
          rates.Grammar = result[2].Score
          rates.Pronunciation = result[3].Score
          rates.Interest = result[4].Score
          if (result[5]) { rates.Confidence = result[5].Score }
        }
        this.isLoading = false
      })
      this.GetWonderfulPictures(this.info.CLID)
    },
    removeGrammar (item, index) {
      // const index = this.GrammarList.indexOf(item)
      if (index >= 0) this.GrammarList.splice(index, 1)
    },
    onSubmit () {
      if (!this.wordKey) return
      if (this.grammarError.maxCharacters) {
        return
      }
      if (this.GrammarList.length >= 9) {
        this.grammarError.maxLength = true
        return
      }
      this.GrammarList.push(this.wordKey)
      this.wordKey = ''
    },
    submit: _debounce(async function () {
      this.submitting = true
      await this.fetchMeterials()
      this.$v.$touch()
      if (this.$v.$invalid || this.grammarError.maxCharacters || this.grammarError.maxLength) {
        this.submitting = false
        return
      }
      var pictureIds = [];
      if(this.wonderfulPictures && this.wonderfulPictures.length){
        pictureIds = this.wonderfulPictures.map(item => item.Id)
      }
      var param = {
        Action: this.info.AllowLeaveRemark === 1 ? 'Add' : 'Edit',
        ClassTools: this.info.ClassTools,
        Uid: this.info.StuUID,
        UCID: this.info.UCID,
        CLID: this.info.CLID,
        SID: this.currentLesson == null ? this.info.SID : this.currentLesson.SID,
        USID: this.info.USID == null ? this.currentLesson.USID : this.info.USID,
        TUID: this.info.TUID,
        ClassTime: this.info.ClassTime,
        Vocabularies: this.GrammarList ? this.GrammarList.join(',') : '',
        Sentences: this.classRemarksForm.Sentences,
        Comments: this.classRemarksForm.Comments,
        ReportID: this.classRemarksForm.ReportID,
        TrailScore: this.classRemarksForm.rates,
        LessonType: this.LessonType,
        PictureIds: pictureIds,
        EvaluationState: this.classRemarksForm.EvaluationState
      }
      if (!this.LessonType) {
        param.CorrectNum = 0
        param.TotalNum = 0
      } else {
        param.CorrectNum = +this.classRemarksForm.CorrectNum,
        param.TotalNum = +this.classRemarksForm.TotalNum
      }
      vipClassRemark(param).then(r => {
        switch (r) {
          case 1 :
            this.successTip('Submit success!')
            // this.$toasted.success('Submit success!')
            this.$store.dispatch('classDetail/fetchInfo', this.$route.params.id)
            this.classRemarks2.dialog = false
            break
          case -2:
            this.errorTip('Invalid Data！')
            // this.$toasted.error('Invalid Data！')
            break
          case -11:
            this.errorTip('Error! Please refresh the page and submit it again')
            // this.$toasted.error('Error! Please refresh the page and submit it again')
            break
          case -3:
            this.errorTip('Sorry ! The lesson has not begun!!')
            // this.$toasted.error('Sorry ! The lesson has not begun!!')
            break
          case -4:
            this.errorTip("There's no textbook! Please report to the CS assign the book for the class.")
            // this.$toasted.error("There's no textbook! Please report to the CS assign the book for the class.")
            break
          case -5:
            this.errorTip('Sorry ! Submission is ONLY allowed AFTER the class.')
            // this.$toasted.error('Sorry ! Submission is ONLY allowed AFTER the class.')
            break
          case -6:
            this.errorTip('Sorry ! Please fill in correct test score.')
            // this.$toasted.error('Sorry ! Please fill in correct test score.')
            break
          case -7:
            this.errorTip('Sorry ! Description Do not exceed 500 in length.')
            break
          case -99:
            this.errorTip('Sorry ! Please fill in the complete data.')
            // this.$toasted.error('Sorry ! Please fill in the complete data.')
            break
          default:
            this.errorTip('Sorry ! Please Select a Teaching Material first.')
            // this.$toasted.error('Sorry ! Please Select a Teaching Material first.')
            break
        }
      }).finally(()=>{
        this.submitting = false
      })
    }),
    GetWonderfulPictures(clid){
      GetWonderfulPictures(clid).then(res => {
        this.wonderfulPictures = res
      })
    },
    successTip (msg) {
      return this.$root.$alertTips(msg, 'success')
    },
    errorTip (msg) {
      return this.$root.$alertTips(msg)
    },
    hidePicture(id){
      this.wonderfulPictures.splice(this.wonderfulPictures.findIndex(item => item.Id === id), 1)
    }
  },
  watch: {
    'classRemarks2.dialog': function (value, oldValue) {
      let usid = this.info.USID
      this.GetRemarkInfo(usid)
    },
    'wordKey': function (val) {
      if (val.length > 20) {
        this.grammarError.maxCharacters = true
        return
      }
      this.grammarError.maxCharacters = false
    }
  }
}
</script>
<style>
.grammar-box .v-chip__close>.v-icon{
  color:#fd7070 !important;
}
</style>
<style lang="scss" scoped>
.grammar-box{
    border: 1px solid rgba(50, 57, 122, 0.4);
    padding: 0 12px;
    min-height: 40px;
    border-radius: 4px;
}
.grammar-box input{
    border: 0;
    height: 38px;
    border: none;
    line-height: 38px;
    font-size: 16px;
    outline: none;
    width: 100%;
    color:$blue-title;
    
}
::-webkit-input-placeholder{ /* WebKit browsers */
  color:rgba(50, 57, 122, 0.4);
}
.required-text{
    color: #ff5252;
    margin-right: 5px;
}
.grammar-error{
    height: 20px;
}
.correct-info{
  overflow: hidden;
  height: 60px;
  line-height: 60px;
}
.correct-info span {
  float: left;
}
.correct-info .float{
  float: left;
}
.v-text-field.v-text-field--solo .v-input__control {
    min-height: 20px!important;
}
.correct-info .v-text-field--outline>.v-input__control>.v-input__slot{
  min-height: 20px!important;
}
.grammar-box .theme--light.v-chip{
  background:#FFDFDB;
  color:$blue-title;
  height:24px;
  border-radius:4px;
}
.w-picture-card{
    width: 30%;
    // float: left;
    margin-right: 3%;
    position: relative;
    .picture-close{
      position: absolute;
      top: -8px;
      right: -8px;
      background: #ff5254;
      border-radius: 50%;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
    img{
      width: 100%;
    }
  }
.objectives-btn{
  width: 140px;
  height: 24px;
  border-radius: 9px;
}
.pink-text{
  font-size: 12px;
  padding-left: 12px;
}

</style>
